export const BLACK_INITIAL_MOVE = ' b - - 0 1'
export const WHITE_INITIAL_MOVE = ' w - - 0 1'
export const BLACK_PIECE_SEARCH_KEY = /^b/
export const WHITE_PIECE_SEARCH_KEY = /^w/
export const BLACK_KING_SEARCH_KEY = /^bK/

export const CAPTURED_PIECE_COLOR_MAPPER = {
  b: 'w',
  w: 'b'
}

export const WHITE_PIECE = 'w'
export const BLACK_PIECE = 'b'

export const ACTIVITY_SUCCESS_AUDIO = {
  src: 'img/audio/lesson_end.mp3',
  start: true,
  controls: false
}

export const CORRECT_ANSWER_AUDIO = {
  src: 'img/audio/correct_answer.mp3',
  start: true,
  controls: false
}

export const WRONG_ANSWER_AUDIO = {
  src: 'img/audio/wrong_answer.mp3',
  start: true,
  controls: false
}

export const ACTIVITY_COMPLETION_AUDIO = {
  src: 'img/audio/activity_complete.mp3',
  start: true,
  controls: false
}

export const GLOBAL_ASSETS = [
  '/img/volume.svg',
  '/img/mute.svg',
  '/img/thinking_bubble.svg',
  '/img/dragon.png',
  '/img/bubble_down.svg',
  '/img/chessboard_indication.svg',
  '/img/chessboard_indication_full.svg',
  '/img/dropdown.png',
  '/img/chesspieces/simple_black_white/bK.svg',
  '/img/chesspieces/simple_black_white/bQ.svg',
  '/img/chesspieces/simple_black_white/bR.svg',
  '/img/chesspieces/simple_black_white/bB.svg',
  '/img/chesspieces/simple_black_white/bN.svg',
  '/img/chesspieces/simple_black_white/bP.svg',
  '/img/chesspieces/simple_black_white/wK.svg',
  '/img/chesspieces/simple_black_white/wQ.svg',
  '/img/chesspieces/simple_black_white/wR.svg',
  '/img/chesspieces/simple_black_white/wB.svg',
  '/img/chesspieces/simple_black_white/wN.svg',
  '/img/chesspieces/simple_black_white/wP.svg'
]










// /img/chesspieces/wikipedia/bK.png
// /img/chesspieces/wikipedia/bQ.png
// /img/chesspieces/wikipedia/bR.png
// /img/chesspieces/wikipedia/bB.png
// /img/chesspieces/wikipedia/bN.png
// /img/chesspieces/wikipedia/bP.png
// /img/chesspieces/wikipedia/wK.png
// /img/chesspieces/wikipedia/wQ.png
// /img/chesspieces/wikipedia/wR.png
// /img/chesspieces/wikipedia/wB.png
// /img/chesspieces/wikipedia/wN.png
// /img/chesspieces/wikipedia/wP.png
// /img/background_1.png
// /img/background_2.png
// /img/background_3.png



// WEBPACK FOOTER //
// ./src/utils/constants.js